import { requestGet } from '@/utils/request';

const api = {
    LIST: '/finance/platform_stat_list',
};

export async function platformStatList(queryParams) {
    return requestGet(api.LIST, queryParams);
}